import { render, staticRenderFns } from "./OnBoardSchedule.vue?vue&type=template&id=5cfe5645"
import script from "./OnBoardSchedule.vue?vue&type=script&lang=js"
export * from "./OnBoardSchedule.vue?vue&type=script&lang=js"
import style0 from "./OnBoardSchedule.vue?vue&type=style&index=0&id=5cfe5645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports